import { Colors } from '../consts/Colors';
import RoundedButton from './RoundedButton';
import RoundedButtonReverted from './RoundedButtonReverted';
import {isMobile} from '../sydo/utils/IsMobile'

export default class EndBoard extends Phaser.GameObjects.Container {
    constructor(xTop, yTop, scene, score) {
        super(scene, xTop, yTop, []);

        scene.add.existing(this);
        this.scene = scene;
        this.score = score;

        this.scoreBox = this.scene.add.rexRoundRectangle(0, 0, 273, 162, 22, Colors.Elmt.Beige).setOrigin(0.5, 0)
        this.add(this.scoreBox);

        this.goodBox = this.scene.add.image(13 - this.scoreBox.width/2, 50, 'goodBox').setOrigin(0, 0.5)
        this.add(this.goodBox);
        let txt = "BONNE\nRÉPONSE"
        if (this.score.bravo > 1) {
            txt = "BONNES\nRÉPONSES"
        }
        this.goodText = this.scene.add.text(this.goodBox.x + 115, this.goodBox.y, txt, {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Green
        }).setOrigin(0, 0.5)
        this.add(this.goodText);

        this.goodScore = this.scene.add.text(this.goodBox.x + 70, this.goodBox.y, this.score.bravo, {
            font: "24px MassiliaRegular",
            color: Colors.Text.White
        }).setOrigin(0.5)
        this.add(this.goodScore);

        this.badBox = this.scene.add.image(this.goodBox.x, 120, 'badBox').setOrigin(0, 0.5)
        this.add(this.badBox);
        txt = "MAUVAISE\nRÉPONSE"
        if (this.score.mauvais > 1) {
            txt = "MAUVAISES\nRÉPONSES"
        }

        this.badText = this.scene.add.text(this.goodText.x, this.badBox.y, txt, {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Red
        }).setOrigin(0, 0.5)
        this.add(this.badText);

        this.badNum = this.scene.add.text(this.goodScore.x, this.badBox.y, this.score.mauvais, {
            font: "24px MassiliaRegular",
            color: Colors.Text.White
        }).setOrigin(0.5)
        this.add(this.badNum);


        var isTrue = false
        var videoReplay = false
        var txtTitre = "Félicitations !"
        txt = "La Trésorerie nette, le Fonds de Roulement et le Besoin en Fonds de Roulement n’ont plus de secret pour vous ! Il est temps de découvrir d’autres quiz."
        if ((this.score.mauvais) <= 9 && (this.score.mauvais) >= 5) {
            txtTitre = "C'est un bon début !"
            txt = "Rejouez avant de découvrir d’autres quiz !"
            // txt = "Rejouez avant de regarder la vidéo suivante sur ******** !"
        } else if ((this.score.mauvais) >= 10) {
            txtTitre = "Vous pouvez faire mieux !"
            txt = "Regardez de nouveau la vidéo et rejouez !"
            videoReplay = true
        } else {
            isTrue = true
        }

        this.title = this.scene.add.text(-171, 244, txtTitre, {
            font: "32px MassiliaExtraBold",
            color: Colors.Text.White,
            align: "left",
            wordWrap: { width: 350}
        }).setOrigin(0, 0.5)
        this.add(this.title);

        this.content = this.scene.add.text(this.title.x, 300, txt, {
            font: "30px MassiliaMedium",
            color: Colors.Text.White,
            align: "left",
            wordWrap: { width: 350}
        }).setOrigin(0)
        this.add(this.content);

        const boutonsInfo = [
            
        ]


        var boutonVideo = undefined
        var boutonRejouer = undefined

        let boutonLinkedin = new RoundedButtonReverted(this.scene, 0, 560, 300, 52, "   Partager", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
        // boutonLinkedin = new RoundedButton(this.scene, 1035 + 382 / 2, 40 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
        this.add(boutonLinkedin);
        let icon = this.scene.add.image(-boutonLinkedin.textButton.width/2, 0, 'logoLinkedin').setOrigin(1, 0.5)
        boutonLinkedin.add(icon)
        boutonLinkedin.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        boutonLinkedin.setTextSize("28px")
        boutonLinkedin.on('pointerover', () => {icon.setTint(Colors.Elmt.DarkBlue)})
        boutonLinkedin.on('pointerout', () => {icon.setTint(Colors.Elmt.White)})
        boutonLinkedin.setClickFunction(() => {
            const text = "&text=✅ Défi trésorerie %3A réussi !%0D%0A%0D%0AJe viens de tester mes connaissances avec un quiz proposé par la Banque de France – EDUCFI.%0D%0A%0D%0A🎯 Verdict %3A mission accomplie%E2%80%A6 et%2C surtout%2C quelques bons réflexes bien ancrés pour mieux piloter sa trésorerie au quotidien.%0D%0A%0D%0AParce que la gestion financière est un enjeu clé pour tous%2C ces formats ludiques sont une excellente manière de se former autrement.%0D%0A%0D%0A👉 Et vous%2C prêt(e)s à relever le défi %EF%BC%9F#overlay_share-modal"
            const url = "https://www.linkedin.com/shareArticle/?url=https%3A%2F%2Fwww.mesquestionsdentrepreneur.fr%2Fsites%2Fbdf_mqde%2Fuploads%2Ftresorerie-nette-simple-comme-compta%2F"
            if(isMobile()){
                window.open(url, '_blank');
            }else{
                window.open(url + text, '_blank');
            }
        })

        if (!isTrue) {
            boutonRejouer = new RoundedButton(this.scene, 0, 630, 144, 52, "Rejouer", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            this.add(boutonRejouer);
            boutonRejouer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonRejouer.setTextSize("28px")
            boutonRejouer.setClickFunction(() => {
                this.scene.game.data.score = {
                    bravo: 0,
                    presque: 0,
                    mauvais: 0
                }
                this.scene.scene.start("Menu")
            })

            boutonVideo = new RoundedButtonReverted(this.scene, 0, 700, 342, 52, "Découvrir d’autres quiz", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
            // boutonVideo = new RoundedButtonReverted(this.scene, 1035 + 382 / 2, 116 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            this.add(boutonVideo);
            boutonVideo.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonVideo.setTextSize("28px")
            boutonVideo.setClickFunction(() => {
                window.open("https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
                // window.open("https://youtu.be/l1nTs54zj7Q?si=a2zWX810A7j4whtg", '_blank');

            })
        } else {
            boutonVideo = new RoundedButton(this.scene, 0, 630, 342, 52, "Découvrir d’autres quiz", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            // boutonVideo = new RoundedButton(this.scene, 1035 + 382 / 2, 40 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            this.add(boutonVideo);
            boutonVideo.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonVideo.setTextSize("28px")
            boutonVideo.setClickFunction(() => {
                window.open("https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
            })

            boutonRejouer = new RoundedButtonReverted(this.scene, 0, 700, 144, 52, "Rejouer", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
            this.add(boutonRejouer);
            boutonRejouer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonRejouer.setTextSize("28px")
            boutonRejouer.setClickFunction(() => {
                this.scene.game.data.score = {
                    bravo: 0,
                    presque: 0,
                    mauvais: 0
                }
                this.scene.scene.start('Menu')
            })
        }
        const boutonTerminer = new RoundedButtonReverted(this.scene, 0, 770, 162, 52, "Terminer", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
        this.add(boutonTerminer);
        boutonTerminer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        boutonTerminer.setTextSize("28px")
        boutonTerminer.setClickFunction(() => {
            // this.nextScene()
            this.scene.scene.start('Fin')
        })
    }

}